import Style from './materialpoptable.module.scss'
import { Table } from 'antd'

export interface tableParam {
  code: string
  name: string
  id: string
  brandEn?: string
  brandIsSale?: string
  [x: string]: any
}
export interface tableresultData {
  current?: number // 当前页
  total?: number // 总条数
  data: tableParam[]
}
interface Props {
  dataSource: tableresultData // 数据
  loading?: boolean // 加载中
  onClickRow?: (e: tableParam) => void // 选中行
  onChangePage?: (page: number, pageSize?: number) => void // 分页操作
  otherCol?: { title: string; dataIndex: string }[]
  rowkey?: string
  nameRender?: any
}

// 物料详情筛选弹窗
const MaterialPopTable = (props: Props) => {
  const {
    dataSource,
    loading,
    onClickRow,
    onChangePage,
    otherCol,
    rowkey,
    nameRender,
  } = props
  return (
    <Table
      rowKey={rowkey ? rowkey : 'id'}
      tableLayout="fixed"
      className={Style['table-box']}
      size="small"
      dataSource={dataSource.data}
      loading={loading}
      onRow={(record) => ({
        className: Style['table-row'],
        onClick: () =>
          onClickRow && record.click !== false ? onClickRow(record) : undefined,
      })}
      // pagination={false}
      pagination={{
        size: 'small',
        showTotal: (text) => `${text}条数据`,
        showSizeChanger: false,
        defaultPageSize: 10,
        total: dataSource.total,
        current: dataSource.current,
        onChange: onChangePage,
      }}
    >
      {/* <Table.Column
				ellipsis
				align='center'
				onHeaderCell={() => ({
					className: Style['table-header'],
				})}
				onCell={() => ({
					className: Style['table-td'],
				})}
				title='编码'
				dataIndex='code'
			/> */}
      <Table.Column
        ellipsis
        align="center"
        onHeaderCell={() => ({
          className: Style['table-header'],
        })}
        onCell={() => ({
          className: Style['table-td'],
        })}
        title="名称"
        dataIndex="name"
        render={nameRender}
      />
      {otherCol
        ? otherCol.map((item, index) => (
            <Table.Column
              key={index + '_b'}
              ellipsis
              align="center"
              onHeaderCell={() => ({
                className: Style['table-header'],
              })}
              onCell={() => ({
                className: Style['table-td'],
              })}
              title={item.title}
              dataIndex={item.dataIndex}
            />
          ))
        : null}
    </Table>
  )
}

export default MaterialPopTable

// 过滤调用的接口数据-本地处理
export const filterData = (
  params: (tableParam & { [x: string]: any })[],
  filterStr?: string,
  page?: string,
): tableresultData => {
  const value = filterStr ? filterStr.toLowerCase() : ''
  const arr = params.filter(
    (item: { name: string; code: string }) =>
      item.name.toLowerCase().indexOf(value) >= 0 ||
      item.code.toLowerCase().indexOf(value) >= 0,
  )
  const p = page ? Number.parseInt(page) : 1
  const startidnex = (p - 1) * 10
  const endindex = p * 10
  const slicedata = arr.slice(startidnex, endindex)
  if (page) {
    return {
      current: p,
      total: arr.length,
      data: slicedata,
    }
  }
  return {
    current: p,
    total: arr.length,
    data: arr,
  }
}
import Style from './materialpoptable.module.scss'
import { Table } from 'antd'

export interface tableParam {
  code: string
  name: string
  id: string
  brandEn?: string
  brandIsSale?: string
  [x: string]: any
}
export interface tableresultData {
  current?: number // 当前页
  total?: number // 总条数
  data: tableParam[]
}
interface Props {
  dataSource: tableresultData // 数据
  loading?: boolean // 加载中
  onClickRow?: (e: tableParam) => void // 选中行
  onChangePage?: (page: number, pageSize?: number) => void // 分页操作
  otherCol?: { title: string; dataIndex: string }[]
  rowkey?: string
  nameRender?: any
}

// 物料详情筛选弹窗
const MaterialPopTable = (props: Props) => {
  const {
    dataSource,
    loading,
    onClickRow,
    onChangePage,
    otherCol,
    rowkey,
    nameRender,
  } = props
  return (
    <Table
      rowKey={rowkey ? rowkey : 'id'}
      tableLayout="fixed"
      className={Style['table-box']}
      size="small"
      dataSource={dataSource.data}
      loading={loading}
      onRow={(record) => ({
        className: Style['table-row'],
        onClick: () =>
          onClickRow && record.click !== false ? onClickRow(record) : undefined,
      })}
      // pagination={false}
      pagination={{
        size: 'small',
        showTotal: (text) => `${text}条数据`,
        showSizeChanger: false,
        defaultPageSize: 10,
        total: dataSource.total,
        current: dataSource.current,
        onChange: onChangePage,
      }}
    >
      {/* <Table.Column
				ellipsis
				align='center'
				onHeaderCell={() => ({
					className: Style['table-header'],
				})}
				onCell={() => ({
					className: Style['table-td'],
				})}
				title='编码'
				dataIndex='code'
			/> */}
      <Table.Column
        ellipsis
        align="center"
        onHeaderCell={() => ({
          className: Style['table-header'],
        })}
        onCell={() => ({
          className: Style['table-td'],
        })}
        title="名称"
        dataIndex="name"
        render={nameRender}
      />
      {otherCol
        ? otherCol.map((item, index) => (
            <Table.Column
              key={index + '_b'}
              ellipsis
              align="center"
              onHeaderCell={() => ({
                className: Style['table-header'],
              })}
              onCell={() => ({
                className: Style['table-td'],
              })}
              title={item.title}
              dataIndex={item.dataIndex}
            />
          ))
        : null}
    </Table>
  )
}

export default MaterialPopTable

// 过滤调用的接口数据-本地处理
export const filterData = (
  params: (tableParam & { [x: string]: any })[],
  filterStr?: string,
  page?: string,
): tableresultData => {
  const value = filterStr ? filterStr.toLowerCase() : ''
  const arr = params.filter(
    (item: { name: string; code: string }) =>
      item.name.toLowerCase().indexOf(value) >= 0 ||
      item.code.toLowerCase().indexOf(value) >= 0,
  )
  const p = page ? Number.parseInt(page) : 1
  const startidnex = (p - 1) * 10
  const endindex = p * 10
  const slicedata = arr.slice(startidnex, endindex)
  if (page) {
    return {
      current: p,
      total: arr.length,
      data: slicedata,
    }
  }
  return {
    current: p,
    total: arr.length,
    data: arr,
  }
}
